import { Coffee } from "lucide-react";
import {
    AppStoreButton,
    GooglePlayButton,
} from "../StoreButtons";

export const DownloadCTA = () => (
    <section
        data-testid="final-cta"
        className="py-24 md:py-32 relative overflow-hidden"
    >
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-10">
            <div className="relative rounded-[2.5rem] bg-[#2D2D2D] text-[#FDF6EE] px-8 md:px-16 py-16 md:py-20 text-center overflow-hidden">
                <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#C4956A]/40 blur-3xl" />
                <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-[#E86A58]/30 blur-3xl" />

                <Coffee className="text-[#C4956A] mx-auto mb-5" size={34} />
                <h2 className="relative font-serif text-4xl md:text-6xl leading-[1.05] text-white">
                    Your next favourite book{" "}
                    <span className="italic text-[#C4956A]">
                        is waiting
                    </span>
                    .
                </h2>
                <p className="relative mt-5 text-[#FDF6EE]/75 max-w-xl mx-auto text-lg">
                    Download BookBlend and find the readers who get it.
                </p>
                <div
                    data-testid="final-cta-buttons"
                    className="relative mt-10 flex flex-wrap items-center justify-center gap-4"
                >
                    <AppStoreButton
                        variant="light"
                        testId="final-cta-appstore"
                    />
                    <GooglePlayButton
                        variant="light"
                        testId="final-cta-googleplay"
                    />
                </div>
                <p className="relative mt-8 text-sm text-[#FDF6EE]/50 font-sans">
                    Launching on the App Store · Android coming soon
                </p>
            </div>
        </div>
    </section>
);
